import { mapGetters } from "vuex";
import pageheader from "../../pageheader";
import utils from "../../../utils/util";
import telematicsService from "../../../api/telematics.service";
import rules from "../../../utils/rules";
export default {
  name: "update-alarm",
  components: { pageheader },
  props: [],
  data() {
    return {
      rules: rules,
      valid: true,
      contactName: "",
      selectedtypeheading: "",
      contactPhone: "",
      contactMobile: "",
      contactEmail: "",
      alarmgetId: "",
      gettingData: false,
      unMatchedUnits: false,
      unMatchedUnitsArr: [],
      isLoaderContacts: false,
      isDisplayunMatchedUnitsDialog: false,
      headers_UnMatched: [
        {
          text: "Name",
          align: "center",
          sortable: false,
          value: "name",
        },
        { text: "Reason", value: "reason" },
      ],

      batteryLevel: 0.0,
      isUpdateAlarm: false,
      isCreatingContact: false,
      parentCompaniesList: [],
      companySelected: {},
      searchEmails: null,
      searchContacts: null,
      isLoaderCust: true,
      isLoaderMachine: false,
      machinesList: [],
      selectedContact: "",
      selectedEmails: "",
      searchCustomer: null,
      alarmName: "",
      alarmTypeList: [
        { name: "Operational Alerts", value: "OperationalAlerts" },
      ],
      alarmTypeListGeo: [
        { name: "By Zone Enter", value: "ByZoneEnter" },
        { name: "By Zone Leave", value: "ByZoneLeave" },
      ],
      phoneNumberMask: "+1(###)###-#####",
      contactsList: [],
      emailsList: [],
      isLoaderContact: false,
      AlarmValid: true,
      ContactValid: true,
      alarmType: "OperationalAlerts",
      enableEmails: true,
      enableSms: false,
      emailList: [],
      smsList: "",
      input: {},
      searchMachine: null,
      selectedMachines: [],
      isSelectAllEquipments: false,
      ZoneId: "",
      contactDialog: false,
      geofences: [],
      selectedZone: "",
      loadinggeofence: false,
      menufilter: false,
      selectAlerttype: "CRITICAL",
      Alerttypes: [
        {
          id: "CRITICAL",
          name: "Critical",
        },
        {
          id: "LOW",
          name: "Low",
        },
      ],
      selectedInsight: "",
      InsightsListTypes: [
        {
          id: "BATTERY_VOLTAGE",
          name: "Battery Voltage",
        },
        {
          id: "DEF_TANK_LEVEL",
          name: "DEF tank level",
        },
        { id: "FUEL_LEVEL", name: "Fuel level" },
      ],
      InsightsListTypesLogsitics: [
        {
          id: "ARRIVE",
          name: "Arrive",
        },
        {
          id: "DEPART",
          name: "Depart",
        },
      ],
      selectedInsightLogistic: "ARRIVE",
      selectedOperator: "LESS_THAN",

      OperatorsList: [
        {
          id: "GREATER_THAN",
          name: "is more than (>)",
        },
        {
          id: "LESS_THAN",
          name: "is less than (<)",
        },
      ],
      threshold: null,
      filterTypes: [
        { id: "1", name: "Address" },
        { id: "2", name: "City" },
        { id: "3", name: "State" },
        { id: "4", name: "Zip" },
      ],
    };
  },
  watch: {
    searchMachine(val) {
      if (val != undefined && val && val.length % 2 == 0) {
        this.getMachinesDropdown(val, "");
      }
    },
  },
  computed: {
    ...mapGetters([
      "roles",
      "fullname",
      "id",
      "companyNameDropdown",
      "companyIdDropdown",
    ]),
    likesAllMachines() {
      return this.selectedMachines.length === this.machinesList.length;
    },
    likesSomeMachines() {
      return this.selectedMachines.length > 0 && !this.likesAllMachines;
    },
    iconForMachines() {
      if (this.likesAllMachines) return "mdi-close-box";
      if (this.likesSomeMachines) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  mounted() {
    // this.getMachinesDropdown();
    this.getAlarmContacts();
    this.editAlarmDialog();
    if (this.$route.params.type == "LogisticsAlerts") {
      // this.alarmType = "ByZoneEnter";
      this.selectedtypeheading = "Update Logistics Alert";
      this.getGeofences();
    }
    if (this.$route.params.type == "OperationalAlerts") {
      this.selectedtypeheading = "Update Operational Alerts";
    }
    this.input = utils.getInputContent("updatealerts", this.roles);
  },
  methods: {
    remove(item) {
      const index = this.selectedMachines.indexOf(item.assetId);
      if (index >= 0) this.selectedMachines.splice(index, 1);
    },
    changeSelectAllEquipments() {
      this.selectedMachines = [];
    },
    closeUnmatched() {
      this.isDisplayunMatchedUnitsDialog = false;
    },
    openInfounMatchedUnitsDialog() {
      this.isDisplayunMatchedUnitsDialog = true;
    },
    async getGeofences() {
      this.geofences = [];
      this.loadinggeofence = true;
      try {
        // this.companySelected.id
        let response = await telematicsService.getGeofences();
        if (response && response.data) {
          this.geofences = response.data.map((d, index) => ({
            ...d,
            sno: index + 1,
          }));
        }
        this.loadinggeofence = false;
      } catch (err) {
        this.loadinggeofence = false;
        console.log(err);
      }
    },
    closeContactDialog() {
      this.contactDialog = false;
      this.contactName = "";
      this.contactEmail = "";
      this.contactMobile = "";
      this.contactPhone = "";
    },
    openContactDialog() {
      this.contactDialog = true;
    },
    closeAlarmDialog() {
      this.$router.push({
        path: "/alerts/list",
      });
    },
    async getCompanyList() {
      this.isLoaderCust = true;
      let finalLists = [];
      try {
        const response = await telematicsService.getBasicCustomers();
        if (response.isSuccess) {
          this.isLoaderCust = false;
          finalLists = response.data.filter((e) => e.name !== "");
          // Add All option to the finalLists
          // finalLists.unshift({ id: "", name: "All" });
          // Add ByDefault 'All' to v-model
          // this.companySelected = {
          //       name: "All",
          //       id: "",
          //     };
          this.parentCompaniesList = finalLists;
        } else {
          this.isLoaderCust = false;
          // finalLists.unshift({ id: "", name: "All" });
          this.parentCompaniesList = [];
        }
      } catch (err) {
        this.isLoaderCust = false;
        console.log(err);
      }
    },
    // async getMachinesDropdown() {
    //   this.isLoaderMachine = true;
    //   // let customerId = String(this.companySelected.id);
    //   let customerId =
    //     this.companyNameDropdown == "All" ||
    //     this.companyNameDropdown == "" ||
    //     this.companyNameDropdown == null
    //       ? ""
    //       : String(this.companyIdDropdown);

    //   let machinesList = [];
    //   try {
    //     const response = await telematicsService.getMachinesAlarms(customerId);
    //     if (response.isSuccess) {
    //       this.isLoaderMachine = false;
    //       machinesList = response.data.filter((e) => e.name !== "");

    //       this.machinesList = machinesList;
    //     } else {
    //       this.isLoaderMachine = false;
    //       // finalLists.unshift({ id: "", name: "All" });
    //       this.machinesList = [];
    //     }
    //   } catch (err) {
    //     this.isLoaderMachine = false;
    //     console.log(err);
    //   }
    // },
    async getAlarmContacts() {
      this.isLoaderContacts = true;
      let customerId =
        this.companyNameDropdown == "All" ||
        this.companyNameDropdown == "" ||
        this.companyNameDropdown == null
          ? ""
          : String(this.companyIdDropdown);
      // let customerId = String(this.companySelected.id);
      let contactsList = [];
      let emailsList = [];
      try {
        var response;
        if (this.$route.params.type == "OperationalAlerts") {
          response = await telematicsService.getAlarmBatteryContacts(
            customerId
          );
        }
        if (this.$route.params.type == "LogisticsAlerts") {
          response = await telematicsService.getAlarmBatteryContacts(
            customerId
          );
        }
        if (response.isSuccess) {
          this.isLoaderContacts = false;
          contactsList = response.data;
          emailsList = response.data;
          // contactsList = response.data.filter((e) => e.name !== "");
          console.log(contactsList);
          // emailsList = response.data.filter((e) => e.name !== "");

          this.contactsList = contactsList;
          this.emailsList = emailsList;
          this.isLoaderContacts = false;
        } else {
          this.isLoaderContacts = false;
          // finalLists.unshift({ id: "", name: "All" });
          this.contactsList = [];
          this.emailsList = [];
        }
      } catch (err) {
        this.isLoaderContacts = false;
        console.log(err);
      }
    },
    showHideEmails() {
      console.log(this.enableEmails);
    },
    showHideSms() {
      console.log(this.enableSms);
    },

    toggleMachines() {
      this.$nextTick(() => {
        if (this.likesAllMachines) {
          this.selectedMachines = [];
        } else {
          this.selectedMachines = this.machinesList
            .map((item) => item.assetId)
            .slice();
        }
      });
    },
    async createContact() {
      // let customerId = String(this.companySelected.id);
      let customerId =
        this.companyNameDropdown == "All" ||
        this.companyNameDropdown == "" ||
        this.companyNameDropdown == null
          ? ""
          : String(this.companyIdDropdown);

      // var outMobile = this.contactMobile.replace(/[^a-zA-Z0-9]/g, "");
      // console.log(outMobile)
      let payload = {
        name: this.contactName,
        email: this.contactEmail,
        phone: this.contactMobile,
      };
      console.log(payload);
      try {
        var response;
        if (this.$route.params.type == "OperationalAlerts") {
          response = await telematicsService.CreateAlarmBatteryContacts(
            customerId,
            payload
          );
        }
        if (this.$route.params.type == "LogisticsAlerts") {
          response = await telematicsService.CreateAlarmContacts(
            customerId,
            payload
          );
        }
        if (response.isSuccess) {
          this.$toast.success("Contact updated successfully");
          this.isCreatingContact = false;
          this.closeContactDialog();
          this.getAlarmContacts();
        } else {
          this.$toast.error(response.systemMessage);
          this.isCreatingContact = false;
        }
      } catch (err) {
        this.isCreatingContact = false;

        this.$toast.error("Unable to create the Contact" + err);
      }
    },
    async getMachinesDropdown(value, units) {
      this.machinesList = [];
      this.isLoaderMachine = true;
      // let customerId = String(this.companySelected.id);
      let customerId =
        this.companyNameDropdown == "All" ||
        this.companyNameDropdown == "" ||
        this.companyNameDropdown == null
          ? ""
          : String(this.companyIdDropdown);

      let machinesList = [];
      try {
        const response = await telematicsService.getMachinesAlarms(
          customerId,
          value,
          units
        );

        if (response.isSuccess) {
          this.isLoaderMachine = false;
          machinesList = response.data.filter((e) => e.name !== "");
          this.machinesList = machinesList;
        } else {
          this.isLoaderMachine = false;
          // finalLists.unshift({ id: "", name: "All" });
          this.machinesList = [];
        }
      } catch (err) {
        this.isLoaderMachine = false;
        console.log(err);
      }
    },
    async editAlarmDialog() {
      this.alarmgetId = this.$route.params.id;

      this.alarmDialogEdit = true;
      try {
        let response = await telematicsService.getAlarmsById(
          this.$route.params.id
        );

        this.gettingData = true;
        this.alarmName = response.data.alert.name;
        this.selectAlerttype =
          response.data.alert.configurationDetails.criticality;
        if (this.$route.params.type == "OperationalAlerts") {
          this.selectedInsight =
            response.data.alert.configurationDetails.operationalAlert.type;
          this.selectedOperator =
            response.data.alert.configurationDetails.operationalAlert.operator;
          this.threshold = parseFloat(
            response.data.alert.configurationDetails.operationalAlert.threshold
              .doubleValue
          );
        }
        if (this.$route.params.type == "LogisticsAlerts") {
          this.selectedInsightLogistic = "ARRIVE";
          this.selectedZone =
            response.data.alert.configurationDetails.logisticLoggingAlert !=
            null
              ? response.data.alert.configurationDetails.logisticLoggingAlert
                  .siteId
              : "";
          // response.data.alert.configurationDetails.logisticLoggingAlert.type;
        }
        // this.selectedMachines = response.data.alert.assetFilter.ids;

        this.enableEmails =
          response.data.alert.subscribers != undefined &&
          response.data.alert.subscribers != null
            ? true
            : false;
        this.selectedEmails =
          response.data.alert.subscribers != undefined &&
          response.data.alert.subscribers != null
            ? response.data.alert.subscribers.contactEmailRecipients
            : "";
        //
        if (response.data.alert.assetFilter.assetFilterType == "ALL_FLEET") {
          this.isSelectAllEquipments = true;
          this.machinesList = [];
        }

        this.machinesList =
          response.data.rentAndReservationItems != null
            ? response.data.rentAndReservationItems
            : [];
        if (response.data.alert.assetFilter.assetFilterType == "ASSET") {
          this.isSelectAllEquipments = false;
          this.selectedMachines =
            response.data.rentAndReservationItems != null
              ? response.data.rentAndReservationItems
                  .filter((e) => e.isSelected)
                  .map((a) => a.assetId)
              : [];
        }
        if (
          response.data.unMatchedUnits == null ||
          response.data.unMatchedUnits.length == 0
        ) {
          this.unMatchedUnits = false;
          this.unMatchedUnitsArr = [];
        } else {
          this.unMatchedUnits = true;
          this.unMatchedUnitsArr = response.data.unMatchedUnits;
        }

        //
      } catch (err) {
        this.gettingData = false;
        this.$toast.error("Unable to get the alerts data" + err);
      }
    },
    async updateAlarm() {
      let emailsData;
      // let contactsData;
      if (this.enableEmails) {
        emailsData = this.selectedEmails ? this.selectedEmails.join(",") : "";
      } else {
        emailsData = "";
      }

      var payload;
      if (this.$route.params.type == "OperationalAlerts") {
        payload = {
          id: this.alarmgetId,
          name: this.alarmName,

          allAssets: this.isSelectAllEquipments,
          assetIds:
            this.selectedMachines && this.isSelectAllEquipments == false
              ? this.selectedMachines.join(",")
              : "",
          type: this.selectedInsight,
          criticality: this.selectAlerttype,
          operator: this.selectedOperator,
          threshold: parseFloat(this.threshold),
          contacts: emailsData,
        };
        console.log(payload);
      }
      if (this.$route.params.type == "LogisticsAlerts") {
        payload = {
          id: this.alarmgetId,
          name: this.alarmName,

          criticality: this.selectAlerttype,
          allAssets: this.isSelectAllEquipments,
          assetIds:
            this.selectedMachines.length > 0 &&
            this.isSelectAllEquipments == false
              ? this.selectedMachines.join(",")
              : "",
          type: this.selectedInsightLogistic,
          siteId: this.selectedZone,
          contacts: emailsData,
          zoneId: this.selectedZone,
        };
      }
      // console.log(payload);
      if (this.selectedMachines.length != 0 || this.isSelectAllEquipments) {
        this.isUpdateAlarm = true;

        try {
          var response;
          if (this.$route.params.type == "OperationalAlerts") {
            response = await telematicsService.UpdateOperationalAlerts(
              this.alarmgetId,
              payload
            );
          }
          if (this.$route.params.type == "LogisticsAlerts") {
            response = await telematicsService.UpdateLogisticsAlerts(
              this.alarmgetId,
              payload
            );
          }
          if (response.isSuccess) {
            this.$toast.success("Alarm updated successfully");
            this.isUpdateAlarm = false;
            this.alarmDialogEdit = false;
            this.closeAlarmDialog();
          } else {
            this.$toast.error(response.systemMessage);
            this.isUpdateAlarm = false;
          }
        } catch (err) {
          this.isUpdateAlarm = false;
          this.$toast.error("Unable to update the Alarm" + err);
        }
      } else {
        this.$toast.error("Please select atleast one machine");
      }
    },
    // remove(item) {
    //   this.emailList = this.emailList.filter((e) => e.id != item.id);
    //   this.selectedEmails = this.selectedEmails.filter((e) => e.id != item.id);
    // },
    // // remove(item) {
    // //   const index = this.group.machines.indexOf(item.stockKey);
    // //   if (index >= 0) this.group.machines.splice(index, 1);
    // // },
    // remove1(item) {
    //   this.contactsList = this.contactsList.filter((e) => e.id != item.id);
    //   this.selectedContact = this.selectedContact.filter(
    //     (e) => e.id != item.id
    //   );
    // },
  },
};
